// src/App.js
import React, { useEffect } from 'react';
import './amplifyConfig';
import '@aws-amplify/ui-react/styles.css';
import { Authenticator } from '@aws-amplify/ui-react';
import { Routes, Route } from 'react-router-dom';
import Box from '@mui/joy/Box';

import Navigation from './components/Navigation';
import Dashboard from './components/Dashboard';
import InventoryTable from './components/InventoryTable';
import LiveListingsPage from './views/LiveListingsPage';
import Settings from './components/Settings';
import { clearSettingsCache } from './utils/settings';
import { startAutoProcessing, stopAutoProcessing } from './api/orders';

export default function App() {
  // Clear settings cache on app mount to ensure fresh data
  useEffect(() => {
    clearSettingsCache();
    
    // Start the auto-processing system for order data import
    startAutoProcessing().catch(err => {
      console.error('Failed to start order data import:', err);
    });
    
    // Clean up when component unmounts
    return () => {
      stopAutoProcessing();
    };
  }, []);

  return (
    <Authenticator variation="modal">
      {() => (
        <Box sx={{ 
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)'
        }}>
          <Navigation />

          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/seeds" element={<InventoryTable type="PRODUCT-SEED" />} />
            <Route path="/clones" element={<InventoryTable type="PRODUCT-CLONE" />} />
            <Route path="/packaging" element={<InventoryTable type="SHIPPING_MATERIAL" />} />
            <Route path="/live-listings" element={<LiveListingsPage />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </Box>
      )}
    </Authenticator>
  );
}
